
// import React, { useEffect, useState } from 'react';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, TextField, Button, MenuItem, Select, FormControl, IconButton, useTheme, Box, Autocomplete
// } from '@mui/material';
// import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
// import AddIcon from '@mui/icons-material/Add';
// import { tokens } from "../../theme/theme'/theme'";
// import FetchDataFromApi, { callApi } from "../commonapicall/fetchdata";
// import { API_ENDPOINTS } from "../commonapicall/apiCall";

// const ContactTable = ({ contacts, setContacts }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   const [designation, setDesignation] = useState([]);
//   const [isDataLoaded, setIsDataLoaded] = useState(false);
//   const [department, setDepartment] = useState([]);
//   const [isDepartmentLoaded, setIsDepartmentLoaded] = useState(false);

//   // Load Designation list
//   useEffect(() => {
//     if (!isDataLoaded) {
//       const para = { p_companyid: 1 };
//       callApi(API_ENDPOINTS.DESIGNATION_GET, 'POST', { 'Content-Type': 'application/json' }, para)
//         .then(data => {
//           if (data && data.length > 0) {
//             setDesignation(data);
//             setIsDataLoaded(true);
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching designations:', error);
//         });
//     }
//   }, [isDataLoaded]);

//   // Load Department list
//   useEffect(() => {
//     if (!isDepartmentLoaded) {
//       const para = { p_companyid: 1 };
//       callApi(API_ENDPOINTS.DEPARTMENT_GET, 'POST', { 'Content-Type': 'application/json' }, para)
//         .then(data => {
//           if (data && data.length > 0) {
//             setDepartment(data);
//             setIsDepartmentLoaded(true);
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching departments:', error);
//         });
//     }
//   }, [isDepartmentLoaded]);

//   const [newContact, setNewContact] = useState({
//     salutation: 'Mr',
//     firstName: '',
//     lastName: '',
//     email: '',
//     workPhone: '',
//     mobile: '',
//     designation: null,
//     designationId: '',
//     department: null,
//     departmentId: '',
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewContact(prevState => ({
//       ...prevState,
//       [name]: value
//     }));
//   };

//   const handleAutocompleteChange = (name, value) => {
//     setNewContact(prevState => ({
//       ...prevState,
//       [name]: value,
//       [`${name}Id`]: value?.id || ''
//     }));
//   };

//   const addContact = () => {
//     setContacts([...contacts, {
//       ...newContact,
//       designation: newContact.designation?.description || '',
//       department: newContact.department?.description || ''
//     }]);
//     setNewContact({
//       salutation: 'Mr',
//       firstName: '',
//       lastName: '',
//       email: '',
//       workPhone: '',
//       mobile: '',
//       designation: null,
//       designationId: '',
//       department: null,
//       departmentId: '',
//     });
//   };

//   const removeContact = (index) => {
//     const updatedContacts = contacts.filter((_, i) => i !== index);
//     setContacts(updatedContacts);
//   };

//   return (
//     <div>
//       <Box
//         gridColumn="span 9"
//         gridRow={"span 2"}
//         alignItems="center"
//         justifyContent="center"
//         padding={1}
//         sx={{
//           "& .MuiTable-root": { border: "none", size: "small" },
//           "& .MuiTableCell-root": {
//             borderBottom: "none",
//             border: "1px solid",
//             borderColor: `${colors.primary[400]} !important`,
//           },
//           "& .name-column--cell": { color: colors.greenAccent[300] },
//           "& .MuiTableHead-root": { borderBottom: "none" },
//           "& .MuiTableBody-root": { overflowY: "auto" },
//           "& .MuiCheckbox-root": {
//             color: `${colors.blueAccent[200]} !important`,
//             size: "small",
//           },
//           "& .MuiTableFooter-root": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//             height: "10px",
//           },
//           "& .MuiButton-text": { color: `${colors.grey[100]} !important` },
//         }}
//       >
//         <TableContainer>
//           <Table size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Salutation</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>First Name</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Last Name</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Email Address</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Work Phone</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Mobile</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Designation</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Department</TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid transparent', fontSize: '14px' }}></TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {contacts.map((contact, index) => (
//                 <TableRow key={index}>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.salutation}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.firstName}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.lastName}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.email}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.workPhone}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.mobile}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.designation}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>{contact.department}</TableCell>
//                   <TableCell style={{ size: "small", border: '1px solid transparent', fontSize: '14px' }}>
//                     <IconButton onClick={() => removeContact(index)} color="secondary">
//                       <HighlightOffOutlinedIcon sx={{ color: '#ef5350' }} />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//               <TableRow>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <FormControl fullWidth>
//                     <Select
//                       size="small"
//                       name="salutation"
//                       value={newContact.salutation}
//                       sx={{
//                         '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
//                         '& .MuiSelect-select': { padding: '8px' },
//                       }}
//                       onChange={handleInputChange}
//                     >
//                       <MenuItem value="Mr">Mr</MenuItem>
//                       <MenuItem value="Mrs">Mrs</MenuItem>
//                       <MenuItem value="Ms">Ms</MenuItem>
//                       <MenuItem value="Miss">Miss</MenuItem>
//                       <MenuItem value="Dr">Dr</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <TextField
//                     name="firstName"
//                     value={newContact.firstName}
//                     onChange={handleInputChange}
//                     fullWidth
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <TextField
//                     name="lastName"
//                     value={newContact.lastName}
//                     onChange={handleInputChange}
//                     fullWidth
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <TextField
//                     name="email"
//                     value={newContact.email}
//                     onChange={handleInputChange}
//                     fullWidth
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <TextField
//                     name="workPhone"
//                     value={newContact.workPhone}
//                     onChange={handleInputChange}
//                     fullWidth
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <TextField
//                     name="mobile"
//                     value={newContact.mobile}
//                     onChange={handleInputChange}
//                     fullWidth
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <Autocomplete
//                     options={designation}
//                     getOptionLabel={(option) => option.description}
//                     value={newContact.designation}
//                     onChange={(event, newValue) => handleAutocompleteChange('designation', newValue)}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         name="designation"
//                         fullWidth
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                       />
//                     )}
//                   />
//                 </TableCell>
//                 <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', padding: 0 }}>
//                   <Autocomplete
//                     options={department}
//                     getOptionLabel={(option) => option.description}
//                     value={newContact.department}
//                     onChange={(event, newValue) => handleAutocompleteChange('department', newValue)}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         name="department"
//                         fullWidth
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
//                       />
//                     )}
//                   />
//                 </TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box>
//       <Button size='small' sx={{ marginTop: "10px", textTransform: "none" }} onClick={addContact} variant="standard" color="primary" startIcon={<AddIcon />}>
//         Add Contact Person
//       </Button>
//     </div>
//   );
// };

// export default ContactTable;










import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, Button, IconButton, useTheme, Box, Autocomplete, FormControl, Select, MenuItem
} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { tokens } from '../theme/theme';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';

const ContactTable = ({ contacts, setContacts }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [designation, setDesignation] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [department, setDepartment] = useState([]);
  const [isDepartmentLoaded, setIsDepartmentLoaded] = useState(false);

  useEffect(() => {
    if (!isDataLoaded) {
      const para = { p_companyid: 1 };
      callApi(API_ENDPOINTS.DESIGNATION_GET, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDesignation(data);
            setIsDataLoaded(true);
          }
        })
        .catch(error => console.error('Error fetching designations:', error));
    }
  }, [isDataLoaded]);

  useEffect(() => {
    if (!isDepartmentLoaded) {
      const para = { p_companyid: 1 };
      callApi(API_ENDPOINTS.DEPARTMENT_GET, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDepartment(data);
            setIsDepartmentLoaded(true);
          }
        })
        .catch(error => console.error('Error fetching departments:', error));
    }
  }, [isDepartmentLoaded]);

  const handleInputChange = (index, e) => {
     if (!e?.target?.name) return; // ✅ short-circuit if e or target is missing

    const { name, value } = e.target;
    const updatedContacts = [...contacts];
    updatedContacts[index][name] = value;
    setContacts(updatedContacts);
  };

  const handleAutocompleteChange = (index, name, value) => {
    const updatedContacts = [...contacts];
    updatedContacts[index][name] = value;
    updatedContacts[index][`${name}Id`] = value?.id || '';
    setContacts(updatedContacts);
  };

  const addContact = () => {
    setContacts([...contacts, {
      salutation: 'Mr',
      firstName: '',
      lastName: '',
      email: '',
      workPhone: '',
      mobile: '',
      designation: null,
      designationId: '',
      department: null,
      departmentId: '',
    }]);
  };

  const removeContact = (index) => {
    const updatedContacts = contacts.filter((_, i) => i !== index);
    setContacts(updatedContacts);
  };

  return (
    <Box
      gridColumn="span 9"
      gridRow={"span 2"}
      alignItems="center"
      justifyContent="center"
      // padding={1}
      sx={{
        "& .MuiTable-root": { border: "none", size: "small" },
        "& .MuiTableCell-root": {
          borderBottom: "none",
          border: "1px solid",
          borderColor: `${colors.primary[400]} !important`,
        },
        "& .name-column--cell": { color: colors.greenAccent[300] },
        "& .MuiTableHead-root": { borderBottom: "none" },
        "& .MuiTableBody-root": { overflowY: "auto" },
        "& .MuiCheckbox-root": {
          color: `${colors.blueAccent[200]} !important`,
          size: "small",
        },
        "& .MuiTableFooter-root": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
          height: "10px",
        },
        "& .MuiButton-text": { color: `${colors.grey[100]} !important` },
      }}
    >
      <TableContainer >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width: '10px' }}>Salutation</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' , width: '100px'}}>First Name</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width: '100px' }}>Last Name</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Email Address</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Work Phone</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Mobile</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width: '200px' }}>Designation</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width: '200px' }}>Department</TableCell>
              <TableCell style={{ size: "small", border: '1px solid transparent', fontSize: '14px' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map((contact, index) => {
              const selectedDesignation = designation.find(d => d.id === contact.designationId) || null;
              const selectedDepartment = department.find(d => d.id === contact.departmentId) || null;
              return (
                <TableRow key={index}>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    {/* <TextField
                      name="salutation"
                      value={contact.salutation}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => handleInputChange(index, e)}
                    /> */}
                    <FormControl fullWidth>
                      <Select
                        size="small"
                        name="salutation"
                        value={contact.salutation}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                          '& .MuiSelect-select': { padding: '8px' },
                        }}
                         onChange={(e) => handleInputChange(index, e)} // ✅ good
                      >
                        <MenuItem value="Mr">Mr</MenuItem>
                        <MenuItem value="Mrs">Mrs</MenuItem>
                        <MenuItem value="Ms">Ms</MenuItem>
                        <MenuItem value="Miss">Miss</MenuItem>
                        <MenuItem value="Dr">Dr</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <TextField
                      name="firstName"
                      value={contact.firstName}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => handleInputChange(index, e)}
                    />
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <TextField
                      name="lastName"
                      value={contact.lastName}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => handleInputChange(index, e)}
                    />
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <TextField
                      name="email"
                      value={contact.email}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => handleInputChange(index, e)}
                      //  variant="outlined"
                      error={contact.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)}
                      helperText={
                        contact.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)
                          ? 'Invalid email format'
                          : ''
                      }
                    />

                    {/* <TextField
                      value={contact.email}
                       sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => handleInputChange(index, e)}
                      type="email"
                      ame="email"
                      fullWidth
                      size="small"
                      label=""                     
                      variant="outlined"
                      error={contact.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)}
                      helperText={
                        contact.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)
                          ? 'Invalid email format'
                          : ''
                      }
                      
                    /> */}


                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <TextField
                      value={contact.workPhone}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d*$/.test(input) && input.length <= 10) {
                          handleInputChange(index, e);
                        }
                      }}
                      fullWidth
                      size="small"
                      type="tel"
                      label=""
                      name="workPhone"
                     
                      // variant="outlined"
                      error={contact.workPhone !== '' && !/^[0-9]{10}$/.test(contact.workPhone)}
                      helperText={
                        contact.workPhone !== '' && !/^[0-9]{10}$/.test(contact.workPhone)
                          ? 'Enter a valid 10-digit contact number'
                          : ''
                      }

                    />


                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <TextField
                      value={contact.mobile}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d*$/.test(input) && input.length <= 10) {
                          handleInputChange(index, e);
                        }
                      }}
                      fullWidth
                      size="small"
                      type="tel"
                      label=""
                      name="mobile"
                      
                      // variant="outlined"
                      error={contact.mobile !== '' && !/^[0-9]{10}$/.test(contact.mobile)}
                      helperText={
                        contact.mobile !== '' && !/^[0-9]{10}$/.test(contact.mobile)
                          ? 'Enter a valid 10-digit contact number'
                          : ''
                      }

                    />
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <Autocomplete
                      options={designation}
                      getOptionLabel={(option) => option.description}
                      value={selectedDesignation}
                      onChange={(event, newValue) => handleAutocompleteChange(index, 'designation', newValue)}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <Autocomplete
                      options={department}
                      getOptionLabel={(option) => option.description}
                      value={selectedDepartment}
                      onChange={(event, newValue) => handleAutocompleteChange(index, 'department', newValue)}
                      sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </TableCell>
                  <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                    <IconButton onClick={() => removeContact(index)}>
                      <HighlightOffOutlinedIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell colSpan={9}>
                <Button
                  sx={{ textTransform: 'none' }}
                  onClick={addContact}
                  variant="standard"
                  color="secondary"
                  startIcon={<AddIcon sx={{ color: colors.blueAccent[500] }} />}
                >
                  Add Contact Person
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContactTable;



